import type { FC } from "react";

import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";

import { ListItems, PreviewListItems } from "./ListItems";
import { Loader } from "./Loader";

const Container = styled.div`
    box-sizing: border-box;
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 6px;
    height: 592px;
    overflow: hidden;
`;

const PreviewContainer = styled(Container)`
    height: 300px;
`;

const WithBodyLoaderHOC = (Component: FC) =>
    function Render() {
        const { suggestionsStatus } = useKeywordListComposerContext();
        if (suggestionsStatus === "pending") {
            return <Loader />;
        }
        return <Component />;
    };

const ListItemsWithLoader = WithBodyLoaderHOC(ListItems);

export const Body = () => {
    return (
        <Container>
            <ListItemsWithLoader />
        </Container>
    );
};

const PreviewListItemsWithLoader = WithBodyLoaderHOC(PreviewListItems);

export const PreviewBody = () => {
    return (
        <PreviewContainer>
            <PreviewListItemsWithLoader />
        </PreviewContainer>
    );
};
